import PrivateRouteWithoutLayouts from './PrivateRouteWithoutLayouts';
export default PrivateRouteWithoutLayouts;
